/* istanbul ignore next */
export default class DataSetSnapshot {
    constructor(dataSet) {
        this.dataSet = dataSet;
        this.records = dataSet.records;
        this.originalData = dataSet.originalData;
        this.totalCount = dataSet.totalCount;
        this.currentPage = dataSet.currentPage;
        this.pageSize = dataSet.pageSize;
        this.cachedSelected = dataSet.cachedSelected;
        this.cachedModified = dataSet.cachedModified;
        this.dataToJSON = dataSet.dataToJSON;
        this.children = dataSet.children;
        this.events = dataSet.events;
        this.current = dataSet.current;
    }
}
